import { create } from "zustand";
import { persist } from "zustand/middleware";
import i18n, { type LocaleCode } from "../i18n/i18n.js";

interface LocaleStore {
  locale: LocaleCode;
  setLocale: (locale: LocaleCode) => void;
}

export const useLocaleStore = create<LocaleStore>()(
  persist(
    (set) => ({
      locale: "es" as LocaleCode,
      setLocale: (locale) => {
        void i18n.changeLanguage(locale);
        set({ locale });
      },
    }),
    { name: "locale-preferences" },
  ),
);
